import { Divider } from 'antd';
import React from 'react';

import { useEmojis } from 'app/hooks/data/useEmojis';
import { useExperiencesCategories } from 'app/hooks/data/useExperience';
import type { ExtranetHotelExperience } from 'app/typings/core/extranet/hotel/experiences';

import { ItemPreview } from '../../../../Common/ItemPreview/ItemPreview';
import { formatExperienceName } from '../../../tabViewUtils';
import styles from '../ExperienceConfigurationDrawer.module.scss';

import { LastMinuteConfig } from './LastMinuteConfig/LastMinuteConfig';
import { StockConfig } from './StockConfig/StockConfig';

type ExperienceConfigurationContentProps = {
  experience?: ExtranetHotelExperience;
};

export const ExperienceConfigurationContent: React.FC<
  ExperienceConfigurationContentProps
> = ({ experience }: ExperienceConfigurationContentProps) => {
  const { data: emojis } = useEmojis();
  const { data: experiencesCategories } = useExperiencesCategories();

  const emoji = emojis?.find((e) => e.id === experience?.emoji?.id);
  const categoryName = experiencesCategories?.find(
    (cat) => cat.id === experience?.categoryId
  )?.name;

  const experienceName = experience
    ? formatExperienceName(experience, categoryName)
    : 'Unamed experience';

  return (
    <div className={styles.content}>
      <ItemPreview
        title="ACTIVITY"
        path={emoji?.pictureId}
        alt={emoji?.alt}
        name={experienceName}
      />
      <div className={styles.section}>
        <p className={styles.defaultTitle}>DEFAULT STOCK</p>
        <div className={styles.container}>
          <StockConfig />
          {/* LastMinuteConfig: Hidden until feature is ready for release */}
          {false && (
            <>
              <Divider />
              <LastMinuteConfig />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
